// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13192(4aeb002716)-C06/10/2026-16:11:53-B06/10/2026-16:21:19' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13192(4aeb002716)-C06/10/2026-16:11:53-B06/10/2026-16:21:19",
  branch: "test",
  latestTag: "8.1",
  revCount: "13192",
  shortHash: "4aeb002716",
  longHash: "4aeb00271678c6fd9eef86026e4df14876ac88e6",
  dateCommit: "06/10/2026-16:11:53",
  dateBuild: "06/10/2026-16:21:19",
  buildType: "Ansible",
  } ;
